import { Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CardTokenViewModel, LiveEventViewModel, TipViewModel } from 'src/app/_models/generatedModels';
import { EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'live-tips',
  templateUrl: 'live-tips.component.html',
})
export class LiveTipsComponent implements OnInit {
  initialized = false;
  public cardNumber: string;
  public expMo: string;
  public expYr: string;
  public cvv: string;
  public errorMessage: string;
  submitComplete: Promise<{}> | undefined;

  @Input() event: LiveEventViewModel;
  @Output()
  closed = new EventEmitter();

  tipAmount = 5;
  @ViewChild('theForm') public userFrm: NgForm;

  constructor(private zone: NgZone, private eventService: EventService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.initialized = true;
  }

  markAllTouched() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      console.log(control); // {2}
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty({ onlySelf: true }); // {3}
    });
  }

  resetForm() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      console.log(control); // {2}
      control.markAsPristine({ onlySelf: true });
      control.markAsUntouched({ onlySelf: true }); // {3}
    });
  }

  sendTip() {
     if (!this.userFrm.valid) {
      this.markAllTouched();
      return;
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      this.send(resetButton);
    });
  }

  send(resetButton) {
    let card = { number: this.cardNumber, exp_month: this.expMo, exp_year: this.expYr, cvc: this.cvv };
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        let model = new TipViewModel();
        model.cardToken = response.id;
        model.amount = this.tipAmount;

        this.zone.run(() => {
          this.eventService.addTipToEvent(this.event.id, model).subscribe(
            (result) => {
              if (!result) {
                resetButton();
                this.errorMessage = 'Unable to process transaction';
                return;
              }

              resetButton();

              console.log('here');
              this.toaster.messageDialog('Your Donation has been received and is greatly appreciated! A receipt has been emailed to you.', 'Thank You!').subscribe();
              this.tipAmount = 5;
              this.cardNumber = '';
              this.expMo = '';
              this.expYr = '';
              this.cvv = '';
              this.resetForm();
              this.close();
            },
            (error) => {
              resetButton();
              this.errorMessage = error.error[0];
            }
          );
        });
      } else {
        resetButton();
        this.errorMessage = response.error.message;
      }
    });
  }

  close() {
    this.closed.emit();
  }
}
